// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3So45","unreadBadge":"styles_unreadBadge__2s_95","modalContent":"styles_modalContent__eLdNJ","modal":"styles_modal__3LKQc"};